import { keyframes } from '@mui/material/styles';

const enter = keyframes`
    from { opacity: 0; transform: translateY(-8px); }
    to { opacity: 1; transform: none; }
`;

const raised = (theme) => theme.customShadows.dropdown;

// The strip a column is dropped on to hide it (see GridColumnRemoveZone),
// placed in viewport px by the drag over the top of the table. Dashed and
// quiet while open; red once a release would hide the column; greyed out for
// a column that may not be hidden.
export const removeZoneSx = {
    'position': 'fixed',
    'zIndex': (theme) => theme.zIndex.tooltip,
    'display': 'flex',
    'alignItems': 'center',
    'justifyContent': 'center',
    'gap': 1,
    'px': 2,
    'boxSizing': 'border-box',
    'borderRadius': (theme) => `${theme.shape.toolbarControl}px`,
    'border': '1.5px dashed',
    'borderColor': 'border.input',
    'bgcolor': 'background.paper',
    'boxShadow': raised,
    'color': 'text.secondary',
    'typography': 'body2',
    'pointerEvents': 'none',
    'animation': `${enter} 150ms ease-out`,
    'transition':
        'background-color 120ms ease, border-color 120ms ease, color 120ms ease',
    '& svg': {
        fontSize: 20,
        flexShrink: 0
    },
    '& > span': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },
    '&[data-phase="hot"]': {
        borderStyle: 'solid',
        borderColor: 'error.main',
        // The soft fill over the opaque paper: the toolbar under the zone
        // must not show through.
        backgroundImage: (theme) =>
            `linear-gradient(${theme.palette.error.soft}, ${theme.palette.error.soft})`,
        color: 'error.softText'
    },
    '&[data-phase="locked"]': {
        color: 'text.disabled'
    },
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};

// The column carried to the zone: its head and first cells, following the
// pointer; it shrinks and tips over the zone, about to go.
export const removeGhostSx = {
    'position': 'fixed',
    'top': 0,
    'left': 0,
    'zIndex': (theme) => theme.zIndex.tooltip + 1,
    'pointerEvents': 'none',
    '& > div': {
        overflow: 'hidden',
        borderRadius: (theme) => `${theme.shape.borderRadius}px`,
        border: 1,
        borderColor: 'divider',
        bgcolor: 'background.paper',
        boxShadow: raised,
        opacity: 0.96,
        transformOrigin: 'top left',
        transition: 'transform 120ms ease-out, border-color 120ms ease'
    },
    '&[data-phase="hot"] > div': {
        transform: 'scale(0.88) rotate(-2deg)',
        borderColor: 'error.main'
    },
    '& table': {
        width: '100%',
        tableLayout: 'fixed',
        borderCollapse: 'collapse'
    },
    '& th, & td': {
        position: 'static',
        maxWidth: 'none',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },
    '@media (prefers-reduced-motion: reduce)': {
        '& > div': {
            transition: 'none'
        }
    }
};
